<plyca-ui-scroll-panel [config]="{ styleClass: 'custombar1 scrollPanel' }">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        @if (config().hasHeader) {
          <ng-content />
        }
        <formPlyca
          #formPlycaRef
          class="filter-generic"
          [config]="{ isSubscribeValueChange: true }"
          [formConfig]="formConfig"
          [manageWaitService]="false"
          (valuesFormChange)="onValueChange($event)"
        ></formPlyca>
      </div>
    </div>
  </div>
</plyca-ui-scroll-panel>
